export const showActivityDetailsButton = [
  'delete.pre_bid'
]

export const excludeActivityFromUpdate = [
  'update.pre_bid'
]

export const swapActivityOldNewFields = [
  'delete.pre_bid'
]